"use strict";

window.addEventListener("DOMContentLoaded", () => {
	// Open and close compatible products modal.
	(() => {
		const $modal = document.querySelector("#compatible-products-modal");
		const $openButton = document.querySelector("#compatible-products-open");
		const $closeButton = document.querySelector("#compatible-products-close");

		if (!$modal || !$openButton) {
			return;
		}

		function open_dialog(dialog) {
			dialog.showModal();
			document.body.style.overflowY = "hidden";
		}

		function close_dialog(dialog) {
			dialog.close();
			document.body.style.overflowY = "auto";
		}

		// Open on button click
		$openButton.addEventListener("click", () => {
			open_dialog($modal);
		});

		// Close on backdrop click.
		$modal.addEventListener("click", (event) => {
			if (event.target === $modal) {
				close_dialog($modal);
			}
		});

		// Close on close button click.
		$closeButton.addEventListener("click", () => {
			close_dialog($modal);
		});
	})();

	// Searching in compatible products table.
	(() => {
		const $search    = document.querySelector("#compatible-products-search");
		const $tableRows = document.querySelectorAll("#compatible-products-table tbody tr");

		if (!$search || !$tableRows.length === 0) {
			return;
		}

		function searchTable() {
			const query = $search.value.replaceAll(" ", "").toLowerCase();

			for (const $row of $tableRows) {
				if (query.length > 0) {
					const rowContent = $row.textContent.replaceAll(" ", "").toLowerCase();
					$row.style.display = (rowContent.indexOf(query) !== -1)
						? "table-row"
						: "none";
				} else {
					$row.style.display = "table-row";
				}
			}
		}

		$search.addEventListener("input", searchTable);
		searchTable();
	})();
} );
